import React from "react";

export const HeaderNav: React.FC = () => {
  return <h2>KWC Controle</h2>;
};

export default HeaderNav;
